/**
 * Fxxl Wertgarantie
 *
 * Filename: wertgarantie.js
 *
 * @category  Fahrradxxl
 * @package   Module
 * @author    Janik Kemnade <j.kemnade@fahrrad-xxl.de>
 * @copyright 2024 Fahrrad-xxl.de
 */


import FxxlCore from '@fxxl/core';


export default class FxxlWertgarantie {
    /* Static Variables - GLOBALS
     * ------------------------------------------------------------------------------------------------------------- */
    static ERROR_MESSAGES_PREFIX = 'FxxlWertgarantie';
    static get ERROR_MESSAGE() {
        return {
            // INSTANCE_EXISTS:        `${FxxlWertgarantie.ERROR_MESSAGES_PREFIX}: Call: An Instance exists`,
        };
    }



    /* Static Variables - CONFIG
     * ------------------------------------------------------------------------------------------------------------- */
    static get CONFIG() {
        const storageKeys  = FxxlCore.getConfig().storageKeys;
        const presenceVars = FxxlCore.getConfig().server?.presence?.variables;

        return {
            IS_ACTIVE: presenceVars?.WERTGARANTIE_ACTIVE ?? false,
            PAGE_SESSIONS: {
                ARTIKEL_INSURANCE_PRAEFIX: storageKeys?.pageSessionWertgarantieDeviceInsurancesPraefix,
                WARENKORB_VIEWED_BIKELOCK_POPUP: storageKeys?.pageSessionWertgarantieViewedBikelockPopup,
            }
        };
    }



    /* HANDLE: Artikel Detail
     * ------------------------------------------------------------------------------------------------------------- */
    static handleArtikelDetail() {
        if (!FxxlWertgarantie.CONFIG.IS_ACTIVE) {
            return;
        }

        // EVENT: Click - Wertgarantie Select
        FxxlWertgarantie.artikelDetailEventClickWertgarantieSelect();

        // EVENT: Change - Wertgarantie Select - Handle Default Message
        FxxlWertgarantie.artikelDetailEventChangeWertgarantieSelectHandleDefaultMessage();

        // EVENT: Change - Wertgarantie Select
        FxxlWertgarantie.artikelDetailEventChangeWertgarantieSelect();
    }

    /* HELPER: Session Storage
     * ----------------------------------------------------------- */
    static artikelDetailPageSessionGetInsuranceByVariantId(variantId) {
        if (!variantId) {
            return;
        }

        const key = FxxlWertgarantie.CONFIG.PAGE_SESSIONS.ARTIKEL_INSURANCE_PRAEFIX + variantId;
        return key ? sessionStorage.getItem(key) || null : null;
    }

    static artikelDetailPageSessionSetInsuranceByVariantId(variantId, data) {
        if (!variantId || !data) {
            return;
        }

        const key = FxxlWertgarantie.CONFIG.PAGE_SESSIONS.ARTIKEL_INSURANCE_PRAEFIX + variantId;
        if (key) {
            sessionStorage.setItem(key, data);
        }
    }

    /* EVENT -> Click - Wertgarantie Select
     * ----------------------------------------------------------- */
    static artikelDetailEventClickWertgarantieSelect() {
        $('.fxxl-artikel-detail__wertgarantie').on('click', function (e) {
            if ($(e.target).hasClass('fxxl-select__option')) {
                if ($(e.target).data('value') === 'open_size_selector') {
                    setTimeout(function () {
                        fxxlProductShowSizeSelector();
                        if (isLargeViewport() === true) {
                            M.toast({
                                html: et.data.pvdVariantSelectionL2Missing,
                                classes: 'fxxl-toast'
                            });
                        }
                    }, 100);
                }
                return false;
            }
            var lastSelectedValue = $('#wertgarantie_options').val();
            FxxlWertgarantie.artikelDetailGetInsurancePremium(this, lastSelectedValue);
        });
    }

    /* EVENT -> Change - Wertgarantie Select
     * ----------------------------------------------------------- */
    static artikelDetailEventChangeWertgarantieSelect() {
        $('#wertgarantie_options').on('change', function () {
            var wgKey = $(this).val();
            $('input[name="wertgarantie_key"]').each(function () {
                if (wgKey !== 'default_wg_message') {
                    $(this).val(wgKey);
                } else {
                    $(this).val('');
                }
            });
            if ($(this).val() !== 'default_wg_message') {
                $(this).parent().find('.fxxl-select__input').css('background-image', 'none');
            } else {
                $(this).parent().find('.fxxl-select__input').removeAttr('style');
            }
        });
    }

    /* EVENT -> Change - Size Select -> in 420_artikel_variant_selection.js
     * ----------------------------------------------------------- */

    /* EVENT -> Change - Wertgarantie Select - Handle Default Message
     * ----------------------------------------------------------- */
    static artikelDetailEventChangeWertgarantieSelectHandleDefaultMessage() {
        $('.fxxl-artikel-detail__wertgarantie-select').on('change', function () {
            if (this.value === 'default_option' || this.value === 'open_size_selector') {
                if (isLargeViewport() === false && this.value === 'open_size_selector') {
                    setTimeout(function () {
                        fxxlProductShowSizeSelector();
                    }, 100);
                    this.value = 'default_wg_message';
                    return true;
                }
                this.value = 'default_wg_message';
            }
        });
    }

    /* HANDLE -> Show - Size Select
     * ----------------------------------------------------------- */
    static artikelDetailGetInsurancePremium(selectElement, lastSelectedValue) {
        var pvdVsElement = document.querySelector('.pvd-vs'),
            l2i,
            wgSelectBoxObject = document.getElementById('wertgarantie_options'),
            selectBoxObject = $(wgSelectBoxObject),
            insuranceDeviceType = $(selectElement).data('insurance-device-type'),
            artikelPrice = parseFloat($(selectElement).data('artikel-price')),
            variantId = $('.fxxl-vc-visible').data('vid'),
            wgInsurancePremium,
            artikelPriceChanged = false,
            savedWertgarantieResponse;

        let storedInsuranceData = FxxlWertgarantie.artikelDetailPageSessionGetInsuranceByVariantId(variantId);

        if (pvdVsElement && pvdVsElement.dataset.onlyl1 === 'no') {
            l2i = Number(pvdVsElement.dataset.l2);
            if (l2i === 0) {
                FxxlWertgarantie.artikelDetailShowSelectSizeInDropdown(wgSelectBoxObject);
            } else {
                if (storedInsuranceData !== null) {
                    savedWertgarantieResponse = JSON.parse(storedInsuranceData);

                    artikelPriceChanged = Object.values(savedWertgarantieResponse).some(insurance =>
                        parseFloat(insurance?.vkprice) !== artikelPrice
                    );
                }


                if ((wgSelectBoxObject.fxxlSelectBoxObject.showElementByDefault === false && storedInsuranceData === null) || artikelPriceChanged === true) {
                    wgInsurancePremium = '/json.php?service=getWertgarantieInsurancePremium&insurance_device_type=' + insuranceDeviceType + '&variant_id=' + variantId;
                    fxxlGetAJAXContent(wgInsurancePremium, function (response) {
                        if (response) {
                            if ($.isEmptyObject(response) === false) {
                                // function to remove if has any previous option data
                                FxxlWertgarantie.artikelDetailRemoveWertgarantieOptionElements(selectBoxObject);
                                // function to create new options with wg insurance
                                FxxlWertgarantie.artikelDetailPrepareWertGarantieOptionElement(selectElement, response, insuranceDeviceType, lastSelectedValue);
                                wgSelectBoxObject.fxxlSelectBoxObject.showElementByDefault = true;
                                wgSelectBoxObject.fxxlSelectBoxObject.showSelectBox();

                                // SET: Insurance Data to Session Storage
                                const responseAsJson = JSON.stringify(response);
                                FxxlWertgarantie.artikelDetailPageSessionSetInsuranceByVariantId(variantId, responseAsJson);
                                storedInsuranceData = responseAsJson

                                selectBoxObject.parent().find('.fxxl-select__select-container').removeAttr('style');
                            } else {
                                M.toast({
                                    html: et.data.wertGarantieErrorText,
                                    classes: 'fxxl-toast fxxl-toast--warning'
                                });
                            }
                        }
                    });
                }

                if (storedInsuranceData !== null && artikelPriceChanged === false) {
                    FxxlWertgarantie.artikelDetailRemoveWertgarantieOptionElements(selectBoxObject);
                    FxxlWertgarantie.artikelDetailPrepareWertGarantieOptionElement(selectElement, JSON.parse(storedInsuranceData), insuranceDeviceType, lastSelectedValue);
                    wgSelectBoxObject.fxxlSelectBoxObject.showElementByDefault = true;
                    wgSelectBoxObject.fxxlSelectBoxObject.showSelectBox();
                    selectBoxObject.parent().find('.fxxl-select__select-container').removeAttr('style');
                }
            }
        }
    }

    /* HANDLE -> Change - Size Select
     * ----------------------------------------------------------- */
    static artikelDetailShowSelectSizeInDropdown(selectBox) {
        var optionElement,
            selectBoxObject = $(selectBox),
            wgSelectBoxOption = $('<option class="fxxl-artikel-detail__wertgarantie-option gtm__wertgarantie_select_option"></option>'),
            selectBoxTitle = selectBoxObject.attr('data-select-size-title'),
            selectOptionText = selectBoxObject.attr('data-select-size-option');

        FxxlWertgarantie.artikelDetailRemoveWertgarantieOptionElements(selectBoxObject);
        optionElement = wgSelectBoxOption.clone(true);
        optionElement.attr('data-wg', 'true');
        optionElement.text(selectOptionText);
        optionElement.attr('value', 'open_size_selector');
        selectBoxObject.append(optionElement);
        selectBox.fxxlSelectBoxObject.showElementByDefault = true;
        selectBox.fxxlSelectBoxObject.showSelectBox();
        selectBoxObject.parent().find('.fxxl-select__header-text').text(selectBoxTitle);
    }

    /* HANDLE -> Change - Size Select
     * ----------------------------------------------------------- */
    static artikelDetailPrepareWertGarantieOptionElement(selectElement, response, insuranceDeviceType, lastSelectedValue) {
        var optionElement,
            wgSelectBoxOption = $('<option class="fxxl-artikel-detail__wertgarantie-option gtm__wertgarantie_select_option"></option>'),
            wgPriceProText = {
                'wgPriceProText_1' : $(selectElement).data('price-text-monatlich'),
                'wgPriceProText_12' : $(selectElement).data('price-text-jahrlich'),
            },
            wgSelectBox = $('#wertgarantie_options'),
            selectBoxTitle = wgSelectBox.attr('data-selectbox-header'),
            defaultWgOptions = {
                'default-option': 'default_wg_message',
                'default-tax-info' : 'default_tax_info',
            },
            optionValue;

        wgSelectBox.parent().find('.fxxl-select__header-text').text(selectBoxTitle);

        Object.keys(defaultWgOptions).forEach(function (key) {
            optionValue = defaultWgOptions[key];
            optionElement = wgSelectBoxOption.clone(true);
            optionElement.attr('value', optionValue);
            optionElement.attr('data-wg', 'true');

            if (key === 'default-tax-info') {
                optionElement.prop('disabled', true);
            }
            optionElement.text(wgSelectBox.data(key));
            wgSelectBox.append(optionElement);
        });

        // CREATE Select Options fromm Response data
        Object.keys(response).forEach(insuranceProductType => {
            const insurance = response[insuranceProductType];

            const requiredFields = [
                'price', 'vkprice',
                'devicetype', 'producttype', 'productcode', 'risktypes', 'paymentinterval',
                'select_text', 'warenkorb_text'
            ];

            if (requiredFields.some(field => !insurance?.[field])) {
                return;
            }

            // CREATE: new Option Element and set attributes
            const priceSuffix = wgPriceProText['wgPriceProText_' + insurance.paymentinterval];
            const optionText = `${insurance.select_text} ${insurance.price} ${priceSuffix}`;
            const optionElement = wgSelectBoxOption.clone(true)
                .attr('value', insuranceProductType)
                .attr('data-producttype', insurance.producttype)
                .attr('data-productcode', insurance.productcode)
                .attr('data-wg', 'true')
                .text(optionText);

            // ADD: Option Element to Select Box
            optionElement.insertBefore('.fxxl-artikel-detail__wertgarantie-select option:last');
        });

        wgSelectBox.val(lastSelectedValue);
    }

    /* HANDLE -> Change - Size Select
     * ----------------------------------------------------------- */
    static artikelDetailRemoveWertgarantieOptionElements(selectBoxObject) {
        selectBoxObject.find('option[data-wg="true"]').remove();
    }



    /* HANDLE: Warenkorb Detail
     * ------------------------------------------------------------------------------------------------------------- */
    static handleWarenkorbDetail() {
        const isWarenkorbDetail = site_type === 'warenkorb' && site_name === 'detail';
        if (!isWarenkorbDetail || !FxxlWertgarantie.CONFIG.IS_ACTIVE) {
            return;
        }

        // EVENT: Click - Wertgarantie Read More
        FxxlWertgarantie.warenkorbDetailEventClickReadmore();

        // EVENT: Click - Wertgarantie Agreement Checkbox
        FxxlWertgarantie.warenkorbDetailEventClickAgreementCheckbox();

        // EVENT: Submit - To Checkout 2
        FxxlWertgarantie.warenkorbDetailEventSubmitToCheckout2();

        // EVENT: Load - Bike Lock Slider
        FxxlWertgarantie.warenkorbDetailEventOnloadBikeLockSlider();

        // EVENT: Click - Reopen Bike Lock Slider
        FxxlWertgarantie.warenkorbDetailEventClickReopenBikeSlider();

        // EVENT: Change - Wertgarantie Agreement Checkbox
        FxxlWertgarantie.warenkorbDetailEventChangeAgreementCheckbox();

        // EVENT: Click - ( Bike Lock Slider ) Tzb Add To Cart
        FxxlWertgarantie.warenkorbDetailEventClickBikeLockSliderTzbAddToCart();
    }

    /* HELPER: Session Storage
     * ----------------------------------------------------------- */
    static warenkorbDetailPageSessionSetBikeLockSliderViewedFlag(value) {
        if (typeof value !== 'boolean') {
            return;
        }

        const key = FxxlWertgarantie.CONFIG.PAGE_SESSIONS.WARENKORB_VIEWED_BIKELOCK_POPUP;
        if (key) {
            sessionStorage.setItem(key, value.toString());
        }
    }
    static warenkorbDetailPageSessionGetBikeLockSliderViewedFlag() {
        const key = FxxlWertgarantie.CONFIG.PAGE_SESSIONS.WARENKORB_VIEWED_BIKELOCK_POPUP;
        return key ? sessionStorage.getItem(key) || '' : '';
    }


    /* EVENT -> Click - Wertgarantie Read More
     * ----------------------------------------------------------- */
    static warenkorbDetailEventClickReadmore() {
        const wertGarantieConditionTextContent = $('.fxxl-element-cart__wertgarantie-checkbox');
        let changedHeight = 'none';

        if (wertGarantieConditionTextContent.length > 0) {
            changedHeight = wertGarantieConditionTextContent[0].clientHeight + 'px';
        }

        $('.fxxl-element-cart__wertgarantie-read-more-toggle').on('click', function () {
            const wertGarantieConditionText = $('.fxxl-element-cart__wertgarantie-condition-text');
            const wertGarantieConditionTextContentBoxShadow = $('.fxxl-element-cart__wertgarantie-condition-text-shadow');
            const wertGarantieTextShowMore = $('.fxxl-element-cart__wertgarantie-read-more');
            const wertGarantieTextShowLess = $('.fxxl-element-cart__wertgarantie-read-less');

            if (wertGarantieConditionText.hasClass('active')) {
                wertGarantieConditionText.removeAttr('style');
                wertGarantieConditionText.removeClass('active');
                wertGarantieConditionTextContentBoxShadow.removeAttr('style');
                wertGarantieTextShowMore.removeClass('fxxl-hidden');
                wertGarantieTextShowLess.addClass('fxxl-hidden');
            } else {
                wertGarantieConditionText.addClass('active');
                wertGarantieConditionText.css('max-height', changedHeight);
                wertGarantieConditionTextContentBoxShadow.css('box-shadow', 'none');
                wertGarantieTextShowMore.addClass('fxxl-hidden');
                wertGarantieTextShowLess.removeClass('fxxl-hidden');
            }
        });
    }

    /* EVENT -> Click - Wertgarantie Agreement Checkbox
     * ----------------------------------------------------------- */
    static warenkorbDetailEventClickAgreementCheckbox() {
        const wgConditionCheckboxId = 'wertgarantie_conditions';
        const wertGarantieConditionsCheckbox = $('#' + wgConditionCheckboxId);
        const wertGarantieHiddenInputWarenkorb = $("input[name='wertgarantie_schlossgeprueft']");
        const wertGarantieCheckboxErrorText = $('.fxxl-element-cart__wertgarantie-checkbox-error-text');
        const resetWertgarantieAgreementBaseUrl = '/json.php?service=resetWertgarantieAgreementStatus&customer_agreed=';
        let resetWertgarantieAgreementUrl = '';

        wertGarantieConditionsCheckbox.on('click', function () {
            if ($(this).is(':checked')) {
                wertGarantieHiddenInputWarenkorb.attr('checked', 'checked');
                wertGarantieCheckboxErrorText.removeAttr('style');
                $(this).removeClass('fxxl-input__checkbox-has-error');
                resetWertgarantieAgreementUrl = resetWertgarantieAgreementBaseUrl + 'true';
                fxxlGetAJAXContent(resetWertgarantieAgreementUrl, function (response) {
                    if (response) {
                        return true;
                    }
                });
            } else {
                wertGarantieHiddenInputWarenkorb.removeAttr('checked');
                resetWertgarantieAgreementUrl = resetWertgarantieAgreementBaseUrl + 'false';
                fxxlGetAJAXContent(resetWertgarantieAgreementUrl, function (response) {
                    if (response) {
                        return true;
                    }
                });
            }
        });
    }

    /* EVENT -> Submit - To Checkout 2
     * ----------------------------------------------------------- */
    static warenkorbDetailEventSubmitToCheckout2() {
        const wgConditionCheckboxId = 'wertgarantie_conditions';
        const wertGarantieConditionsCheckbox = $('#' + wgConditionCheckboxId);
        const wertGarantieCheckboxErrorText = $('.fxxl-element-cart__wertgarantie-checkbox-error-text');

        $('#warenkorb_to_checkout2').submit(function (e) {
            if (!wertGarantieConditionsCheckbox.is(":checked")) {
                e.preventDefault();
                FxxlWertgarantie.warenkorbDetailShowWertgarantieCheckboxErrorMessage(wertGarantieCheckboxErrorText, wertGarantieConditionsCheckbox);
            }
        });
    }

    /* ONLOAD || INIT -> Load - Bike Lock Slider
     * ----------------------------------------------------------- */
    static warenkorbDetailEventOnloadBikeLockSlider() {
        const wertgarantieCrossSellingElement = $('.fxxl-modal-wertgarantie-cross-selling');
        const wertgarantieCrossSellingSliderId = 'fxxl-product-cards-wk-slider-1';
        const wertgarantieCrossSellingModalShowDefault = wertgarantieCrossSellingElement.data('show-default');

        let wertgarantieCrossSellingSlider = null;
        let wertgarantieCrossSellingModal = null;

        if (wertgarantieCrossSellingElement.length > 0 && $('#' + wertgarantieCrossSellingSliderId).length > 0) {
            wertgarantieCrossSellingSlider = $('#' + wertgarantieCrossSellingSliderId)[0].fxxlSlider;
            wertgarantieCrossSellingModal = M.Modal.init(wertgarantieCrossSellingElement, {
                onOpenEnd: function () {
                    // Show Navitation Button For Slider
                    var buttonPositions = new FxxlSetupNextPrevButton(wertgarantieCrossSellingSlider);
                    if (wertgarantieCrossSellingSlider.isPrevActive === true) {
                        $('#' + wertgarantieCrossSellingSliderId + '-nav-prev').css({
                            'left': buttonPositions.prev.left + 'px',
                            'top': buttonPositions.prev.top + 'px'
                        }).addClass('fxxl-slider-nav--show');
                    }
                    if (wertgarantieCrossSellingSlider.isNextActive === true) {
                        $('#' + wertgarantieCrossSellingSliderId + '-nav-next').css({
                            'left': buttonPositions.next.left + 'px',
                            'top': buttonPositions.next.top + 'px'
                        }).addClass('fxxl-slider-nav--show');
                    }
                },
                onCloseStart: function () {
                    FxxlWertgarantie.warenkorbDetailPageSessionSetBikeLockSliderViewedFlag(true);
                }
            });

            if (wertgarantieCrossSellingModal.length > 0) {
                const popupSessionFlag = FxxlWertgarantie.warenkorbDetailPageSessionGetBikeLockSliderViewedFlag();

                if (popupSessionFlag !== 'true' && wertgarantieCrossSellingModalShowDefault === 1) {
                    setTimeout(function () {
                        M.Modal.getInstance(wertgarantieCrossSellingElement).open();
                    }, 1500);
                }
            } else {
                FxxlWertgarantie.warenkorbDetailPageSessionSetBikeLockSliderViewedFlag(false);
            }
        }
    }

    /* EVENT -> Click - Reopen Bike Lock Slider
     * ----------------------------------------------------------- */
    static warenkorbDetailEventClickReopenBikeSlider() {
        const wertgarantieCrossSellingElement = $('.fxxl-modal-wertgarantie-cross-selling');

        // Reopen Wertgarantie Cross-Selling slider form label text-link
        $('.fxxl-element-cart__wertgarantie-condition-text--reopen-slider').on('click', function (e) {
            e.preventDefault();
            M.Modal.getInstance(wertgarantieCrossSellingElement).open();
            FxxlWertgarantie.warenkorbDetailPageSessionSetBikeLockSliderViewedFlag(true);
        });
    }

    /* EVENT -> Change - Wertgarantie Agreement Checkbox
     * ----------------------------------------------------------- */
    static warenkorbDetailEventChangeAgreementCheckbox() {
        const wgConditionCheckboxId = 'wertgarantie_conditions';
        const wertGarantieConditionsCheckbox = $('#' + wgConditionCheckboxId);

        // Close Toast-Message as soon as the checkbox is clicked
        wertGarantieConditionsCheckbox.on('change', function () {
            if (this.checked === true) {
                M.Toast.dismissAll();
            }
        });
    }

    /* EVENT -> Click - ( Bike Lock Slider ) Tzb Add To Cart
     * ----------------------------------------------------------- */
    static warenkorbDetailEventClickBikeLockSliderTzbAddToCart() {
        $('.fxxl-tzb-add-to-cart').on('click', function () {
            var currentElement = $(this),
                form = currentElement.closest('form'),
                product,
                additional_data;

            currentElement.prop('disabled', true);
            currentElement.find('.fxxl-tzb-loader').removeClass('hide');
            currentElement.find('.fxxl-tzb-icon').addClass('hide');
            product = form.find('input[name="product"]').val();

            additional_data = {
                'ecommerce' : {
                    'add' : {
                        'actionField' : {
                            'list' : 'Warenkorb Modal passende Produkte'
                        },
                        'products' : [JSON.parse(product)]
                    }
                }
            }
            gtm.pushOnClick(additional_data, 'EECaddToCart');
            currentElement.find('.fxxl-tzb-loader').addClass('hide');
            currentElement.find('.fxxl-tzb-icon').removeClass('hide');
            currentElement.prop('disabled', false);
            currentElement.addClass('fxxl-button--green');
            currentElement.find('.fxxl-button__icon').addClass('hide');
            currentElement.find('.fxxl-info').removeClass('hide');
            window.setTimeout(function () {
                disableTzbButtonInfo(currentElement);
                location.reload();
            }, 2000);
        });
    }

    /* HANDLE -> Show Wertgarantie Checkbox Error Message
     * ----------------------------------------------------------- */
    static warenkorbDetailShowWertgarantieCheckboxErrorMessage(wertGarantieCheckboxErrorText, wertGarantieConditionsCheckbox)
    {
        if (wertGarantieCheckboxErrorText.length > 0 && wertGarantieConditionsCheckbox.length > 0) {
            wertGarantieCheckboxErrorText.css('display', 'block');
            wertGarantieConditionsCheckbox.addClass('fxxl-input__checkbox-has-error');
            M.toast({
                html: wertgarantieCheckboxNotSelected,
                classes: 'fxxl-toast fxxl-toast--warning',
                displayLength: 2000,
            });
            $('html, body').animate({
                scrollTop:wertGarantieConditionsCheckbox.offset().top - 100
            }, 1000);
            wertGarantieConditionsCheckbox.focus();
        }
    }

}
